// Mobile nav toggle
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-category-select]').forEach(select => {
    select.addEventListener('change', function () {
      if (this.value) window.location.assign(this.value);
    });
  });

  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => nav.classList.toggle('nav-open'));
  }

  // Add to cart feedback
  document.querySelectorAll('.product-add-btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const form = this.closest('form');
      if (form) {
        const original = this.textContent;
        this.textContent = 'Added ✓';
        this.style.background = 'var(--gold)';
        this.style.color = 'var(--black)';
        setTimeout(() => {
          this.textContent = original;
          this.style.background = '';
          this.style.color = '';
        }, 1500);
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        }).then(() => {
          // Update cart count
          return fetch('/cart.js');
        }).then(r => r.json()).then(cart => {
          const countEl = document.querySelector('.cart-count');
          if (countEl) countEl.textContent = cart.item_count;
        }).catch(() => {});
      }
    });
  });
});
